// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_6Ga","colMin":"styles_colMin__kUyGc"};